import { useMutation, useQueryClient } from 'react-query';

import uiNotifications from 'services/uiNotification.service';

import * as authService from 'resources/auth/auth.service';

import userService from 'resources/user/user.service';
import * as userHelpers from 'resources/user/user.helpers';

const signin = async (data) => {
  const user = await userService.findByEmail(data.email);

  if (userHelpers.isDeactivated(user)) {
    uiNotifications.showError('Your account has been deactivated. Is there an issue? Contact a team administrator.');
    return null;
  }

  const auth = await authService.signInByPassword({
    email: data.email,
    password: data.password,
  });

  return auth.user;
};

export default function useSignin() {
  const queryClient = useQueryClient();

  return useMutation(
    (requestData) => signin(requestData),
    {
      onSuccess: (response) => {
        if (!response || response.isBadRequest) {
          return;
        }

        queryClient.invalidateQueries('user.currentUser');
      },
    },
  );
}
